import React, { useEffect, useState } from 'react'
import { Card, Row, Container, CardHeader, Col, CardBody, CardTitle, NavItem, TabContent, NavLink, Nav, CardText, Button, TabPane, ListGroup, ListGroupItem } from 'reactstrap'
import Summary from './Summary';
import { Link, useNavigate, useParams } from 'react-router-dom';
import parentsModal from "models/parents.modal"
import AttendanceModel from "models/Attendance.modal"

const ClassvView = () => {
 
  const navigate = useNavigate();
  const params = useParams();
    const [activeTab, setActiveTab] = useState('Basicdetails');
    const [dataList,setDataList]=useState();
    const handleTabClick = (tabId) => {
      setActiveTab(tabId);
    };
    const getTabContentStyle = (tabId) => {
      return {
        display: activeTab === tabId ? 'block' : 'none',
        transition: 'height 0.3s ease-in-out',
        overflow: 'hidden',
      };
    };

    const getListData = async () => {
      // setIsLoading(true);
      await parentsModal
        .listbyParentid(params?.id)
        .then((result) => {
          // setIsLoading(false);
          if (result) {
            setDataList(result?.data?.data);
            console.log("data -> ", result?.data?.data);
          }
        })
        .catch((error) => {
          // helper.sweetalert.toast(error?.response?.data?.message, "warning");
        });
    };
    const[detail,setDetail]= useState()
    const detaildata =async()=>{
      await AttendanceModel.GetClassById(params?.mid)
      .then((result) => {
        
        if (result) {
          setDetail(result?.data?.data);
         
        }
      })
      .catch((error) => {
        console.log("error",error)
      });
    }
    useEffect(()=>{
      getListData();
      detaildata();
    },[])

    console.log("parent detail1111",detail)
  return (
    <div> 
         <Container  className="px-4 py-7">


  <div className="container " >


<div className="row">
  <div className="col-md-12 px-2.5">
    <div className="nav nav-pills flex-column flex-md-row" id="v-pills-tab" role="tablist" style={{ width: '100%' }}>
      <button
        className={`col-md-2 nav-link ${activeTab === 'Basicdetails' ? 'active' : ''}`}
        id="v-pills-home-tab"
        onClick={() => handleTabClick('Basicdetails')}
        type="button"
        role="tab"
        aria-controls="Basicdetails"
        aria-selected={activeTab === 'Basicdetails'}
        style={{ textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', height: "50px", borderRadius: "0", borderTop: "none", border: "1px solid gray", fontSize: "16px" }}
      >
        Summary
      </button>
{/*
      <button
        className={`col-md-2 nav-link ${activeTab === 'StudentDemo' ? 'active' : ''}`}
        id="v-pills-profile-tab"
        onClick={() => handleTabClick('StudentDemo')}
        type="button"
        role="tab"
        aria-controls="StudentDemo"
        aria-selected={activeTab === 'StudentDemo'}
        style={{ textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', height: "50px", borderRadius: "0", borderTop: "none", border: "1px solid gray", fontSize: "16px", }}
      >Changes
      </button>
*/}
      <button
        className={`col-md-2 nav-link ${activeTab === 'Classes' ? 'active' : ''}`}
        id="v-pills-messages-tab"
        onClick={() => 
        {
          navigate(`/admin/attendance/attendance-profile/${params?.mid}/${detail?.parent_id}/00/00`)
        }
        }
        type="button"
        role="tab"
        aria-controls="Classes"
        aria-selected={activeTab === 'Classes'}
        style={{ textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', height: "50px", borderRadius: "0", borderTop: "none", border: "1px solid gray", alignItems: "center", }}
      >
        Attendance
      </button>
      
      <button
        className={`col-md-2 nav-link ${activeTab === 'Payments' ? 'active' : ''}`}
        id="Payments-tab"
        onClick={() => 
          {
            navigate(`/admin/creditmapping/creditmapping-view/${params?.mid}/00`)
          }}
         
        type="button"
        role="tab"
        aria-controls="Payments"
        aria-selected={activeTab === 'Payments'}
        style={{ textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', height: "50px", borderRadius: "0", borderTop: "none", border: "1px solid gray" }}
      >
        Credit Mapping
      </button>
      <button
        className={`col-md-2 nav-link ${activeTab === 'Payroll' ? 'active' : ''}`}
        id="Payments-tab"
        onClick={() => navigate(`/admin/tutorpayroll/view/${params?.mid}/00`)}
        type="button"
        role="tab"
        aria-controls="Payroll"
        aria-selected={activeTab === 'Payroll'}
        style={{ textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', height: "50px", borderRadius: "0", borderTop: "none", border: "1px solid gray" }}
      >
     Payroll
      </button>
    </div>
  </div>
</div>



{/* <div > */}
<div className="col-12  px-0" id="v-pills-tabContent" style={{ border: '1px solid gray', padding: '20px', marginTop: "5px" }}>
<div style={getTabContentStyle('Basicdetails')}>
  <CardBody>
    {/* <BasicDetails  data={dataList}/> */}
    <Summary data={dataList} detail={detail}/>
  </CardBody>
</div>
<div style={getTabContentStyle('StudentDemo')}>
  <CardBody>
  <Container style={{ marginTop: '20px', }}>
  <h3 style={{ marginBottom: '20px' }}>Package History</h3>
     
      <table bordered>
        <thead>
          <tr>
            <th>Date</th>
            <th>Package</th>
            <th>Charge from client</th>
            <th>Salary pay to tutor</th>
            <th>Tutor name</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>5 Jun 24</td>
            <td>1 hour, 5 sessions a week | 21 in a month</td>
            <td>₹185 per hour | 3885</td>
            <td>₹125 per hour | 2625</td>
            <td>Shivansh</td>
          </tr>
          <tr>
            <td>16 March 24</td>
            <td>1 hour, 5 sessions a week | 21 in a month</td>
            <td>₹215 per hour | 3885</td>
            <td>₹185 per hour | 2625</td>
            <td>Kunal</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="5">
              <a href="#" className="text-primary">History</a>
            </td>
          </tr>
        </tfoot>
      </table>
    </Container>
  </CardBody>
</div>
<div style={getTabContentStyle('Classes')}>
  <CardBody>
    {/* <Classes /> */}
  </CardBody>
</div>
<div style={getTabContentStyle('Payments')}>
  <CardBody>
    {/* <Payments /> */}
  </CardBody>
</div>
</div>
{/* </div> */}

</div>
  </Container>
</div>
  )
}

export default ClassvView